import type { Options } from 'highcharts';
import { formatNumber } from '@mais-retorno-front/helpers/util-helpers';
import theme from '@mais-retorno-front/theme/theme';
import Highcharts from 'highcharts';
import { renderTooltipFromProfitChartPRimeComponents } from './helper';

export const chartOptionsDefault: Highcharts.Options = {
  title: { text: null },
  chart: {
    zooming: {
      type: 'x',
      mouseWheel: {
        enabled: false,
      },
    },
    type: 'line',
    panning: { enabled: false },
    spacing: [10, 10, 0, 0],
    backgroundColor: 'transparent',
  },
  credits: { enabled: false },
  exporting: { enabled: false },
  legend: {
    enabled: true,
    align: 'left',
    verticalAlign: 'top',
  },
  navigator: { enabled: false },
  scrollbar: { enabled: false },
  rangeSelector: { enabled: false },
  plotOptions: {
    series: {
      lineWidth: 2.6,
      color: theme.palette.secondary.main,
      compare: 'percent',
      compareBase: 0,
      compareStart: true,
    },
  },
  xAxis: {
    type: 'datetime',
    lineWidth: 1,
    lineColor: '#BBB',
    dateTimeLabelFormats: {
      month: {
        main: '%m/%y',
      },
      day: {
        main: '%d/%m/%y',
      },
      week: {
        main: '%m/%y',
      },
      year: {
        main: '%Y',
      },
    },
  },
  yAxis: {
    title: { text: null },
    opposite: false,
    lineWidth: 0,
    tickPixelInterval: 35,
    lineColor: '#666',
    gridLineDashStyle: 'Dot',
    gridLineColor: '#BBB',
    plotLines: [
      {
        color: '#CCC',
        width: 1,
        value: 0,
        zIndex: 2,
      },
    ],
    startOnTick: true,
    endOnTick: true,
    max: null,
    labels: {
      formatter() {
        return formatNumber(this.value, { type: 'percent' });
      },
    },
  },
  series: [],
  tooltip: {
    shared: true,
    split: false,
    shadow: false,
    useHTML: true,
    borderRadius: 4,
    backgroundColor: 'rgba(255,255,255,0.85)',
    borderColor: '#CCC',
    formatter() {
      return renderTooltipFromProfitChartPRimeComponents.call(this, 'percent');
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxHeight: 270,
        },
      },
    ],
  },
};

export const VOLATILITY_CHART_OPTIONS = {
  ...chartOptionsDefault,
  legend: { enabled: false },
  plotOptions: {
    series: {
      ...chartOptionsDefault.plotOptions.series,
      lineWidth: 1.4,
      compare: null,
      compareStart: null,
    },
  },
} as Options;

export const CHART_TITLES = {
  drawdown: 'Drawdown',
  volatility: 'Volatilidade',
};
